module.exports = "<p>\n  request-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/request/request-grid/request-grid.component.html
// module id = ./src/app/recovery/request/request-grid/request-grid.component.html
// module chunks = main